import { BrowserLog } from '../../logger/browser-log/browser-log';
import axios from '../../utils/axios';
import { createConfigExtendersCollection } from './create-config-extenders-collection';
/**
 * Создаёт api на основе декларации
 * @param apiDeclaration Декларация
 * @param config Дополнительная конфигурация api
 */
export function initApi(apiDeclaration, { getConfigExtenders, resultHandlers, useBrowserLogger }) {
    const api = {};
    let configExtender;
    // Wrap with axios and apply config extenders
    Object.keys(apiDeclaration).forEach((key) => {
        api[key] = async (params, { logger, ...transportConfig } = {}) => {
            let axiosConfig = apiDeclaration[key](params);
            axiosConfig = {
                ...axiosConfig,
                ...transportConfig,
            };
            if (!configExtender) {
                configExtender = getConfigExtenders(createConfigExtendersCollection());
            }
            axiosConfig = configExtender(axiosConfig, transportConfig);
            if (logger) {
                logger.apiRequest(axiosConfig);
            }
            try {
                let result = await axios(axiosConfig);
                if (resultHandlers) {
                    resultHandlers.forEach((handler) => {
                        result = handler(result);
                    });
                }
                if (logger) {
                    logger.apiResponseSuccess(axiosConfig, result);
                }
                return result;
            }
            catch (error) {
                let errorResult = error;
                if (resultHandlers) {
                    resultHandlers.forEach((handler) => {
                        errorResult = handler(errorResult);
                    });
                }
                if (useBrowserLogger && !axios.isCancel(errorResult)) {
                    BrowserLog.sendBrowserApiError(errorResult, axiosConfig);
                }
                if (logger) {
                    if (errorResult.isAxiosError) {
                        logger.apiResponseError(axiosConfig, errorResult);
                    }
                    else {
                        logger.apiInternalError(axiosConfig, error);
                    }
                }
                throw error;
            }
        };
        api[key].displayName = key;
        api[key].apiDeclaration = apiDeclaration[key];
    });
    return api;
}
